import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { backend_url } from "../../App";
import {
//   showLoadingScreen,
  setSnackBar,
} from "../../reusable_components/site_data/siteDataSlice";

// Helper for auth headers
const getAuthHeader = () => ({
  Authorization: `Token ${localStorage.getItem("token")}`,
});

// Async Thunks
export const fetchSensors = createAsyncThunk(
  "sensors/fetchSensors",
  async (params = {}, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(`${backend_url}/core/api/sensors/`, {
        headers: getAuthHeader(),
        params,
      });
      return response.data;
    } catch (error) {
      dispatch(
        setSnackBar(error.response?.data?.error || "Failed to fetch sensors"),
      );
      return rejectWithValue(error.response?.data);
    }
  },
);

export const fetchSensorStats = createAsyncThunk(
  "sensors/fetchSensorStats",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(`${backend_url}/core/api/sensors/`, {
        headers: getAuthHeader(),
        params: { page_size: 1000 }, // Get all sensors for accurate stats
      });
      return response.data;
    } catch (error) {
      dispatch(
        setSnackBar(
          error.response?.data?.error || "Failed to fetch sensor stats",
        ),
      );
      return rejectWithValue(error.response?.data);
    }
  },
);

// Initial State
const initialState = {
  sensors: {
    results: [],
    count: 0,
    loading: false,
  },
  stats: {
    total: 0,
    temperature: 0,
    humidity: 0,
    other: 0,
  },
  error: null,
};

// Slice
const sensorSlice = createSlice({
  name: "sensors",
  initialState,
  reducers: {
    clearSensorError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Sensors
      .addCase(fetchSensors.pending, (state) => {
        state.sensors.loading = true;
      })
      .addCase(fetchSensors.fulfilled, (state, action) => {
        state.sensors.loading = false;
        state.sensors.results = action.payload.results || action.payload;
        state.sensors.count = action.payload.count || action.payload.length;

        // Calculate stats
        const sensors = action.payload.results || action.payload || [];
        const tempCount = sensors.filter(
          (s) => s.sensor_type === "Temperature",
        ).length;
        const humidCount = sensors.filter(
          (s) => s.sensor_type === "Humidity",
        ).length;

        state.stats = {
          total: sensors.length,
          temperature: tempCount,
          humidity: humidCount,
          other: sensors.length - tempCount - humidCount,
        };
      })
      .addCase(fetchSensors.rejected, (state, action) => {
        state.sensors.loading = false;
        state.error = action.payload;
      })

      // Fetch Sensor Stats
      .addCase(fetchSensorStats.pending, (state) => {
        state.sensors.loading = true;
      })
      .addCase(fetchSensorStats.fulfilled, (state, action) => {
        state.sensors.loading = false;
        const sensors = action.payload.results || action.payload || [];

        const tempCount = sensors.filter(
          (s) => s.sensor_type === "Temperature",
        ).length;
        const humidCount = sensors.filter(
          (s) => s.sensor_type === "Humidity",
        ).length;

        state.stats = {
          total: sensors.length,
          temperature: tempCount,
          humidity: humidCount,
          other: sensors.length - tempCount - humidCount,
        };
      })
      .addCase(fetchSensorStats.rejected, (state, action) => {
        state.sensors.loading = false;
        state.error = action.payload;
      });
  },
});

// Selectors
export const selectSensors = (state) => state.sensors.sensors;
export const selectSensorStats = (state) => state.sensors.stats;
export const selectSensorsLoading = (state) => state.sensors.sensors.loading;
export const selectSensorsError = (state) => state.sensors.error;

export const { clearSensorError } = sensorSlice.actions;
export default sensorSlice.reducer;
